import { render, staticRenderFns } from "./ExamEditor.vue?vue&type=template&id=6cddc4a3&scoped=true&"
import script from "./ExamEditor.vue?vue&type=script&lang=ts&"
export * from "./ExamEditor.vue?vue&type=script&lang=ts&"
import style0 from "./ExamEditor.vue?vue&type=style&index=0&id=6cddc4a3&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cddc4a3",
  null
  
)

export default component.exports